var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Soongjin Park
 * @contact sjpark@detech.co.kr
 * @date 2022-05-09
 * @brief Alarm 컴포넌트
 * 1초당 rerandering 발생
 *
 ********************************************************************/
import React, { useState, useEffect } from "react";
import { useRecoilValue } from "recoil";
// recoil state
import { userInfoLoginState } from '../../recoil/userState';
import { useTrans } from "../../utils/langs/useTrans";
import * as HTTPUTIL from "../../utils/api/HttpUtil";
import * as CONST from "../../utils/Const";
/**
* @brief Alarm 컴포넌트
* @param
* @returns react components
*/
function AlarmCount(props) {
    //trans
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //props
    const setParentAlarmCount = props.setAlarmCount;
    const alarmCountReload = props.alarmCountReload;
    const setParentAlarmCountReload = props.setAlarmCountReload;
    //
    const [alarmCount, setAlarmCount] = useState(0);
    useEffect(() => {
        getAlarmCountUnRead();
    }, [alarmCountReload]);
    let timer = null;
    function getAlarmCountUnRead() {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/api/v2/notice/unreadcount`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    //clog("IN ALARM COUNT : RES : " + JSON.stringify(data.body));
                    setAlarmCount(data.body);
                    setParentAlarmCount(data.body);
                    setParentAlarmCountReload(false);
                }
                else {
                }
            }
        });
    }
    useEffect(() => {
        timer = setInterval(() => {
            getAlarmCountUnRead();
        }, 60000);
        return () => {
            clearInterval(timer);
        };
    }, []);
    return (React.createElement("p", null, (alarmCount > 99) ? "99+" : alarmCount));
}
export default AlarmCount;
